import { render } from "./GlobalFooter.vue?vue&type=template&id=517c194a&ts=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=ts"
export * from "./GlobalFooter.vue?vue&type=script&lang=ts"

import "./GlobalFooter.vue?vue&type=style&index=0&id=517c194a&lang=scss"

import exportComponent from "/home/runner/work/billygrossman.com/billygrossman.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__